<div class="card">
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-between flex-nowrap">
      <div class="h3 ml-3">
        Număr matricol:
        {{ animalData !== undefined ? animalData.numarmatricol : "" }}
      </div>

      <a
        class="btn btn-success"
        [routerLink]="previousRoute"
        ngbTooltip="Pagina anterioară"
        placement="left"
      >
        <span class="mdi mdi-arrow-left-bold"></span>
        Înapoi
      </a>
    </div>

    <div
      *ngIf="loadingDataSpinner"
      class="spinner-border text-info table-spinner avatar-xxl"
      role="status"
    ></div>

    <table
      class="table table-bordered table-striped"
      [ngClass]="{ disabled: loadingDataSpinner }"
    >
      <thead>
        <tr>
          <th scope="column" colspan="2">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <h4 class="d-none d-md-block">Informații Animal</h4>

              <div
                id="tickets-table_filter"
                class="d-flex justify-content-end"
              >
                <button
                  *ngIf="isAdmin || isOperator || isFermier; else view"
                  type="button"
                  class="btn btn-success"
                  (click)="openEditAnimalModal('edit')"
                >
                  <span class="btn-label"
                    ><i class="mdi mdi-square-edit-outline"></i></span
                  >Editează
                </button>
                <ng-template #view>
                  <button
                    type="button"
                    class="btn btn-success"
                    (click)="openEditAnimalModal('view')"
                  >
                    <span class="btn-label"
                      ><i class="mdi mdi-eye-outline"></i></span
                    >Vizualizează
                  </button>
                </ng-template>

                <button
                  *ngIf="isAdmin || isOperator"
                  type="button"
                  class="btn btn-info"
                  (click)="generateFisaAnimal(animalData.id)"
                >
                  Fișă animal
                </button>

                <button
                  *ngIf="isAdmin || isOperator"
                  type="button"
                  class="btn btn-warning"
                  (click)="descarcaIstoric(animalData.id)"
                >
                  Descarcă istoric
                </button>

                <button
                  *ngIf="isAdmin || isOperator"
                  type="button"
                  class="btn btn-secondary"
                  (click)="clickSolicitareTestADN(animalData.id)"
                >
                  Solicitare Test ADN
                </button>

                <button
                  *ngIf="isAdmin || isOperator"
                  type="button"
                  class="btn btn-secondary"
                  (click)="clickFisaBonitare(animalData)"
                >
                  Fișa Bonitare
                </button>
              </div>

            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <th scope="row">Status</th>
          <td>
            <span>
              {{
                animalData !== undefined
                  ? animalData.status === 1
                    ? "Activ"
                    : "Inactiv"
                  : ""
              }}
            </span>
          </td>
        </tr>
        <tr>
          <th scope="row">Sex</th>
          <td>
            <span>
              {{
                animalData !== undefined
                  ? animalData.sex === 1
                    ? "Mascul"
                    : "Femelă"
                  : ""
              }}
            </span>
          </td>
        </tr>
        <tr>
          <th scope="row">Data nașterii</th>
          <td>
            {{
              animalData !== undefined
                ? animalData !== undefined
                  ? animalData.datanastere
                  : ""
                : ""
            }}
          </td>
        </tr>
        <tr>
          <th scope="row">Produs prin</th>
          <td>{{ insamantareLabel }}</td>
        </tr>
        <tr *ngIf="animalData && animalData.sex != 1">
          <th scope="row">Categorie Femelă</th>
          <td>{{ femeleCategoryLabel }}</td>
        </tr>
        <tr>
          <th scope="row">Culoare</th>
          <td>{{ colorLabel }}</td>
        </tr>
        <tr>
          <th scope="row">Proprietar</th>
          <td>
            {{ ownerLabel }}
            <a
              *ngIf="codExploatatie"
              [routerLink]="'/dashboard/exploatatie/'
                + codExploatatie
                +'/animale-exploatatie'"
              target="_blank"
              class="fs-3 ml-4"
              title="Pagina exploatației"
            ><i class="mdi mdi-open-in-new"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="col-8">
        <img src="{{ defaultAnimalImage }}" class="w-100" />
      </div>
      <div class="col-4">
        <div class="row" *ngFor="let image of otherAnimalImages">
          <img src="{{ image }}" class="w-100" />
        </div>
      </div>
    </div>
  </div>
</div>

<app-add-update-animal
  [modalData]="addEditModalData"
  (notifyClose)="closeAddEditModal()"
>
</app-add-update-animal>

<app-solicitare-test-adn [modalData]="solicitareTestADNModalData">
</app-solicitare-test-adn>

<app-fisa-bonitare [modalData]="fisaBonitareModalData">
</app-fisa-bonitare>
